import { useEffect, useState } from "react";
import width from "../../SimpleForm/BaseInputs/helper";
import { useRef } from "react";

export const LinkageSelectInput = ({
  formApi,
  formValues,
  schemaProps,
  input,
}) => {
  const defaultOption = { value: "- Select -" };
  const [selectableOptions, setSelectableOptions] = useState([defaultOption]);
  const [isChecked, setIsChecked] = useState(false);
  const selectInputRef = useRef(null);

  // Address County updates separately
  const [countyData, setCountyData] = useState({});

  const {
    linkages: {
      dynamicUpdatesBySelection,
      showDynamicUpdatesCheckbox,
      countyField,
    },
    machine_name,
  } = schemaProps;

  useEffect(() => {
    dynamicallyCreateOptions();
  }, [isChecked]);

  useEffect(() => {
    if (isChecked && showDynamicUpdatesCheckbox) {
      dynamicUpdatesBySelection && dynamicallyUpdateBySelection(selectInputRef);
    }
  }, [selectableOptions]);

  // Address County updates separately
  useEffect(() => {
    const { fieldName, fieldValue } = countyData;
    if (fieldName && fieldValue) {
      formApi.change(`add_values_field[0][${fieldName}]`, fieldValue);
    }
  }, [countyData]);

  const dynamicallyCreateOptions = () => {
    let masterOptions = [];
    dynamicUpdatesBySelection?.forEach((updateItem) => {
      const { setOptionFromFieldArray, dynamicUpdates, setOptionFromField } =
        updateItem;
      if (setOptionFromFieldArray) {
        // Dynamically update by referencing form field array
        let fieldArrayOption = {};
        formValues?.[setOptionFromFieldArray]?.forEach((item) => {
          const value = item?.[setOptionFromField];
          if (value) {
            dynamicUpdates?.forEach(({ set, from, ifCheckboxed }) => {
              if ((ifCheckboxed && isChecked) || ifCheckboxed === undefined) {
                fieldArrayOption[set] = item?.[from];
              }
            });
            masterOptions.push({
              ...fieldArrayOption,
              value,
            });
          }
        });
      } else {
        // Dynamically update by referencing single form field
        let fieldOption = {};
        const value = formValues?.[setOptionFromField];
        if (value) {
          dynamicUpdates?.forEach(({ set, from, to, ifCheckboxed }) => {
            // Set value from another field
            if ((ifCheckboxed && isChecked) || ifCheckboxed === undefined) {
              fieldOption[set] = formValues?.[from] || to;
            }
          });
          masterOptions.push({
            ...fieldOption,
            value,
          });
        }
      }
      setSelectableOptions([defaultOption, ...masterOptions]);
    });
  };

  const dynamicallyUpdateBySelection = (e) => {
    const { selectedIndex } = e?.target || e?.current || 0;
    const { value, ...restOfOptions } = selectableOptions?.[selectedIndex];

    for (const [fieldName, fieldValue] of Object.entries(restOfOptions)) {
      formApi.change(`add_values_field[0][${fieldName}]`, fieldValue);

      // Address County separately due to race conditions with state fields
      if (fieldName === countyField) {
        setCountyData({ fieldName, fieldValue });
      }
    }
  };

  return (
    <>
      <select
        id={input?.name}
        className={`usa-select grid-col-${width(schemaProps)}`}
        {...input}
        onChange={(e) => {
          input?.onChange(e);
          dynamicUpdatesBySelection && dynamicallyUpdateBySelection(e);
        }}
        ref={selectInputRef}
      >
        {selectableOptions?.map(({ value }, index) => {
          return (
            !!value && (
              <option
                key={`${value}_${index}`}
                value={value}
                selected={index === 0}
              >
                {value}
              </option>
            )
          );
        })}
      </select>
      {showDynamicUpdatesCheckbox && (
        <div
          className="usa-checkbox"
          style={{ marginTop: "16px", display: "flex" }}
        >
          <input
            type="checkbox"
            id={`dynamic-updates-${machine_name}`}
            name={`dynamic-updates-${machine_name}`}
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            className={`usa-checkbox__input`}
          />
          <label
            for={`dynamic-updates-${machine_name}`}
            className="usa-checkbox__label"
            style={{
              display: "inline",
            }}
          >
            {showDynamicUpdatesCheckbox}
          </label>
        </div>
      )}
    </>
  );
};
